import {
    Button, FormControl, FormLabel, VStack, Input, Flex, Text,
    Divider, Icon, FormErrorMessage, SimpleGrid, Checkbox, Collapse, Stack
} from '@chakra-ui/react'
import React, { useEffect, useMemo, useRef } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { BsArrowCounterclockwise, BsSearch } from 'react-icons/bs'
import QueueSearch from '../../classes/QueueSearch'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import { useUserContext } from '../../context/userContext'
import { SelectQueueGroup, SelectQueueSearchStatus, SelectResidence } from '../shared'

const SearchForm = () => {
    const defaultValues = QueueSearch.DEFAULT_VALUE
    const { control, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({ defaultValues })
    const { setQuery } = useSearchQueryContext()
    const { userData } = useUserContext()

    const onSubmit = (data) => {
        const value = new QueueSearch(data)
        setQuery(value)
    }

    const resetForm = () => {
        reset(defaultValues)
    }

    const initData = useRef()
    initData.current = () => {
        const value = new QueueSearch(defaultValues)
        setQuery(value)
    }

    const isAdmin = useMemo(() => userData.isAcceptRoles([1, 2]), [userData])

    useEffect(() => {
        initData.current()
    }, [])

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <VStack mt={4} w="full">
                <SimpleGrid w="full" columns={isAdmin ? { base: 1, lg: 2 } : { base: 1, lg: 3 }} spacing={2}>
                    <FormControl isRequired={watch("search_all")} isInvalid={errors.name}>
                        <FormLabel>ชื่อ-นามสกุล</FormLabel>
                        <Controller
                            name="name"
                            control={control}
                            render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกชื่อ หรือนามสกุล" {...field} />}
                        />
                        <FormErrorMessage>กรุณากรอกชื่อที่ต้องการค้นหา</FormErrorMessage>
                    </FormControl>
                    {
                        isAdmin &&
                        <FormControl>
                            <FormLabel>ตัวเลือกสำหรับผู้ดูแลระบบ</FormLabel>
                            <Controller
                                name="search_all"
                                control={control}
                                render={({ field }) => <Checkbox isChecked={watch("search_all")} {...field}>เลือกค้นหาข้อมูลจากทุกอาคาร</Checkbox>}
                            />
                        </FormControl>
                    }
                    <Collapse in={!watch("search_all")}>
                        <FormControl>
                            <FormLabel>อาคาร</FormLabel>
                            <SelectResidence control={control} isClearable={false} required={false} />
                        </FormControl>
                    </Collapse>
                    <Collapse in={!watch("search_all")}>
                        <FormControl isInvalid={errors.queue_group} isRequired>
                            <FormLabel>ระดับ</FormLabel>
                            <SelectQueueGroup control={control} residenceID={watch("residence")?.value} setValue={setValue} />
                            <FormErrorMessage>กรุณาเลือกระดับ</FormErrorMessage>
                        </FormControl>
                    </Collapse>
                    {  // for admin
                        isAdmin &&
                        <FormControl>
                            <FormLabel>สถานะ</FormLabel>
                            <SelectQueueSearchStatus control={control} required={false} disableDiscliamStatus={false} isClearable={false}/>
                        </FormControl>
                            
                    }
                </SimpleGrid>
                <Stack direction={{base:"column",md:"row"}} w={{base:"full",md:"fit-content"}}>
                    <Button w={{base:"full",md:"fit-content"}} type="submit" colorScheme="blue" fontSize="md" leftIcon={<BsSearch />}>
                        ค้นหา
                    </Button>
                    <Button w={{base:"full",md:"fit-content"}} type="reset" colorScheme="yellow" fontSize="md" leftIcon={<BsArrowCounterclockwise />} onClick={() => resetForm()}>
                        ล้างฟอร์ม
                    </Button>
                </Stack>
            </VStack>
        </form>
    )
}

const SearchQueuePanel = () => {
    return (
        <Flex w="full" direction="column" p={4} shadow="lg" borderRadius={4}>
            <Text><Icon as={BsSearch} mr={2} />ค้นหา</Text>
            <Divider />
            <SearchForm />
        </Flex>
    )
}
export default SearchQueuePanel
